import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { getYears } from '../../utils/commonFunctions';

type CustomTimePickerProps = {
    onChange: (value: dayjs.Dayjs | null) => void;
    value: number | null;
    disabled?: boolean;
    minDateTime?: Dayjs;
    maxDateTime?: Dayjs;
}

const CustomTimePicker: React.FC<CustomTimePickerProps> = ({ onChange, value, disabled, minDateTime, maxDateTime }) => {

    return (
        <div className='d-flex align-items-center border rounded-1 overflow-hidden p-0 w-100'>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                    disabled={disabled || false}
                    sx={{
                        flex: '1 1 0%',
                        borderRadius: '0px',
                        background: 'rgba(10, 10, 10, 0.65)!important',
                        '.MuiFormControl-root': {
                            paddingRight: '0px',
                        },
                        '.MuiInputBase-input': {
                            fontSize: '13px !important',
                        },
                        '.MuiOutlinedInput-input': {
                            fontSize: '13px !important',
                            padding: '7px 10px !important',
                        },
                        '.MuiOutlinedInput-root': {
                            height: '30px !important',
                            paddingRight: '0px'
                        },
                        '.MuiInputAdornment-root': {
                            display: 'none',
                        },
                        '.MuiOutlinedInput-notchedOutline': {
                            borderRadius: '0px',
                            border: 'none',
                            borderRight: '0.5px solid rgba(240,240,240,0.30) !important',
                        },
                        '.Mui-disabled': {
                            '-webkit-text-fill-color': 'rgba(240,240,240,0.6) !important',
                            'color': 'rgba(240,240,240,0.6) !important',
                            cursor: 'auto'
                        }
                    }}
                    className="rounded-3"
                    ampm={false} format='YYYY-MM-DD HH:mm:ss'
                    shouldDisableYear={(date) => {
                        const current_year = dayjs(date).year();
                        const yearList = getYears(2002, 2037);
                        return !yearList.includes(current_year);
                    }}
                    views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
                    minDateTime={minDateTime} // if undefined, it's ignored
                    maxDateTime={maxDateTime}
                    value={dayjs.utc(value)}
                    onChange={onChange}
                />
            </LocalizationProvider>
            <span className='opacity-75 fs-12 px-2'>UTC</span>
        </div>
    )
}

export default CustomTimePicker